module.exports = __webpack_public_path__ + "img/casa-white.d27f4aed.svg";